import { render, staticRenderFns } from "./CardsOverview.vue?vue&type=template&id=96fbd9a6&scoped=true&"
import script from "./CardsOverview.vue?vue&type=script&lang=js&"
export * from "./CardsOverview.vue?vue&type=script&lang=js&"
import style0 from "./CardsOverview.vue?vue&type=style&index=0&id=96fbd9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fbd9a6",
  null
  
)

export default component.exports